export const IMAGES = {
  heroCovers: {
    kobiety: "/covers/kobiety.jpg",
    chlopcy: "/covers/chlopcy.png",
    wakacje: "/covers/wakacje.jpg",
    szkola: "/covers/szkola.jpg",
  },
  creator:
    "https://customer-assets-jt897jd0.emergentagent.net/job_hero-showcase-120/artifacts/h37wuvli_ja.jpg",
  child:
    "https://images.unsplash.com/flagged/photo-1551887373-6edba6dacbb1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

const TOC = {
  kobiety: ["/covers/spis1.png", "/covers/spis2.png"],
  chlopcy: ["/covers/spis3.png", "/covers/spis4.png"],
};

export const SHOP_URL = "https://www.naffy.io/justyna-skowronska";

export const PRODUCTS = [
  {
    title: "Jak rozpoznać autyzm u dziewczynek i kobiet",
    type: "E-book PDF",
    desc: "Maskowanie, różnice społeczne i późne diagnozy u dziewczynek i kobiet.",
    link: "https://www.naffy.io/justyna-skowronska/jak-rozpoznac-autyzm-u-dziewczynek-i-kobiet-0ax",
    price: "74 zł",
    featured: false,
    image: "/covers/kobiety.jpg",
    toc: TOC.kobiety,
    tone: "from-[#EDE9FE] to-[#F5F3FF]",
    long: [
      "Ten e-book pomoże Ci lepiej zrozumieć, jak autyzm może przejawiać się u dziewczynek i kobiet na różnych etapach życia. W przystępny sposób wyjaśnia m.in. zjawisko maskowania, różnice w funkcjonowaniu społecznym oraz powody, dla których wiele kobiet otrzymuje diagnozę dopiero w dorosłości.",
      "Publikacja oparta jest na aktualnych badaniach naukowych oraz przykładach z praktyki zawodowej autorki. Dzięki licznym przykładom i studiom przypadków pomaga spojrzeć na spektrum autyzmu z szerszej i bardziej zrozumiałej perspektywy.",
    ],
  },
  {
    title: "Jak rozpoznać autyzm u chłopców i mężczyzn",
    type: "E-book PDF",
    desc: "Jak autyzm przejawia się u chłopców i mężczyzn, od dzieciństwa po dorosłość.",
    link: "https://www.naffy.io/justyna-skowronska/jak-rozpoznac-autyzm-u-chlopcow-i-mezczyzn-n8w",
    price: "74 zł",
    featured: false,
    image: "/covers/chlopcy.png",
    toc: TOC.chlopcy,
    tone: "from-[#E0E7FF] to-[#EEF2FF]",
    long: [
      "Ten e-book pomaga zrozumieć, jak autyzm może przejawiać się u chłopców i mężczyzn na różnych etapach życia – od wczesnego dzieciństwa po dorosłość.",
      "W publikacji znajdziesz opis najczęstszych sygnałów spektrum autyzmu, przykłady zachowań w codziennych sytuacjach oraz wyjaśnienie, jak autyzm może wpływać na relacje, komunikację i funkcjonowanie w szkole oraz w pracy.",
      "E-book oparty jest na aktualnych badaniach naukowych oraz przykładach z praktyki zawodowej autorki.",
    ],
  },
  {
    title: "Mega Pakiet",
    type: "2 e-booki PDF",
    desc: "Oba przewodniki w jednym pakiecie, pełny obraz spektrum u dzieci i dorosłych.",
    link: "https://www.naffy.io/justyna-skowronska/pakiet-jak-rozpoznac-autyzm-dziewczynka-chlopiec-x2p",
    price: "122 zł",
    featured: true,
    badge: "Najlepsza wartość",
    images: ["/covers/kobiety.jpg", "/covers/chlopcy.png"],
    toc: [...TOC.kobiety, ...TOC.chlopcy],
    tone: "from-[#C4B5FD] to-[#F9A8D4]",
    long: [
      `Najkorzystniejszy zestaw: oba przewodniki w jednym pakiecie: „Jak rozpoznać autyzm u dziewczynek i kobiet” oraz „Jak rozpoznać autyzm u chłopców i mężczyzn”.`,
      "Dzięki obu publikacjom zyskujesz pełny obraz spektrum autyzmu na różnych etapach życia, z uwzględnieniem różnic między dziewczynkami/kobietami a chłopcami/mężczyznami. Oba e-booki oparte są na aktualnych badaniach naukowych oraz przykładach z praktyki zawodowej autorki.",
    ],
  },
  {
    title: "Wakacje w spektrum",
    type: "E-book wakacyjny",
    desc: "Praktyczny przewodnik, jak zaplanować spokojne wakacje z dzieckiem w spektrum.",
    link: "https://www.naffy.io/justyna-skowronska/wakacje-w-spektrum-lct",
    price: "47 zł",
    featured: false,
    image: "/covers/wakacje.jpg",
    tone: "from-[#FCE7F3] to-[#FDF2F8]",
    long: [
      "Wyjazd z dzieckiem w spektrum autyzmu nie musi oznaczać stresu i ciągłego gaszenia pożarów. Ten e-book to praktyczny przewodnik pełen gotowych rozwiązań, które pomogą Ci lepiej przygotować się do podróży i wspierać dziecko w trudnych sytuacjach.",
    ],
    bulletsTitle: "W środku znajdziesz:",
    bullets: [
      "praktyczne strategie oparte na moim doświadczeniu,",
      "historyjki społeczne,",
      "pomoce wizualne,",
      "checklisty do wydruku,",
      "wakacyjne aktywności dla dzieci.",
    ],
    outro:
      "To ponad 80 stron praktycznej wiedzy, dzięki której poczujesz się pewniej, a wakacje staną się spokojniejsze i bardziej przewidywalne dla całej rodziny.",
  },
  {
    title: "Szkoła w spektrum",
    type: "Workbook PDF",
    desc: "Praktyczny workbook, który przygotuje dziecko do szkoły i trudnych sytuacji.",
    isNew: true,
    link: "https://www.naffy.io/justyna-skowronska/szkola-w-spektrum-knh",
    price: "97 zł",
    featured: false,
    image: "/covers/szkola.jpg",
    tone: "from-[#DCFCE7] to-[#F0FDF4]",
    long: [
      "Dla wielu dzieci w spektrum autyzmu szkoła to nie tylko nauka, ale też hałas, zmiany, niejasne zasady, presja społeczna i trudne emocje. Workbook „Szkoła w spektrum” pomaga dziecku zrozumieć szkolną rzeczywistość, przygotować się na trudne sytuacje i wiedzieć, co zrobić, gdy nie wie, jak zareagować.",
      "Dla rodzica: spokojnie przygotujesz dziecko do rozpoczęcia lub powrotu do szkoły. Porozmawiacie o obawach, emocjach, relacjach z rówieśnikami, granicach i proszeniu o pomoc, a także o tym, jak rozpoznać niebezpieczną sytuację i komu o niej powiedzieć.",
      "Dla nauczyciela, pedagoga lub terapeuty: gotowe materiały do wydruku na zajęcia indywidualne, godziny wychowawcze lub pracę z całą klasą. Oszczędzasz godziny potrzebne na samodzielne przygotowywanie kart i pomocy wizualnych.",
    ],
    bulletsTitle: "W środku znajdziesz:",
    bullets: [
      "7 praktycznych rozdziałów, 157 stron materiałów,",
      "ponad 30 kart pracy,",
      "historyjki społeczne, rutyny i pomoce wizualne,",
      "plakaty oraz materiały do wycinania,",
      "ćwiczenia dotyczące emocji, zachowania i regulacji,",
      "materiały wspierające proszenie o pomoc,",
      "ćwiczenia o przyjaźni, konfliktach, granicach i bezpieczeństwie,",
      "karty w dwóch wariantach: A (werbalny) i B (obrazkowy).",
    ],
    outro:
      "Zestaw praktycznych narzędzi, do których wracasz przez cały rok szkolny, zawsze gdy pojawi się nowa trudność, zmiana czy rozmowa. Pomóż dziecku zrobić pierwszy krok w stronę spokojniejszej szkoły.",
  },
];

export const BENEFITS = [
  {
    icon: "BookOpen",
    title: "Praktyczna wiedza",
    body: "Konkretne wskazówki, które możesz wdrożyć od razu. Wszystkie rozwiązania opierają się nie tylko na aktualnej wiedzy, ale również na doświadczeniu zawodowym autorki i rzeczywistych sytuacjach z pracy z dziećmi oraz ich rodzinami.",
  },
  {
    icon: "Printer",
    title: "Pomoce do wydrukowania",
    body: "Każdy e-book zawiera praktyczne dodatki, takie jak np. pomoce wizualne, które wystarczy pobrać i wydrukować.",
  },
  {
    icon: "MailCheck",
    title: "Format PDF",
    body: "Natychmiastowa dostawa na e-mail, korzystasz z materiałów od razu po zakupie.",
  },
];

export const STEPS = [
  { n: "01", title: "Wybierasz produkt", body: "Wybierz e-book lub pakiet dopasowany do Twoich potrzeb." },
  { n: "02", title: "Płacisz bezpiecznie online", body: "Szybka i bezpieczna płatność w kilka sekund." },
  { n: "03", title: "E-book trafia na e-mail", body: "Plik PDF otrzymujesz na skrzynkę w 60 sekund." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Przeczytałam oba e-booki i bardzo polecam je rodzicom, zarówno tym, którzy zastanawiają się nad diagnozą, jak i tym, których dzieci już ją mają. Napisane dostępnym, zrozumiałym językiem. Sama od lat jestem terapeutką i na pewno polecę je innym specjalistom, nauczycielom i studentom: to dobrze usystematyzowana, merytoryczna wiedza, aktualne badania i wiele przykładów z praktyki autorki.",
    name: "Julka Wołoszyn",
    role: "Terapeutka",
  },
  {
    quote:
      "Znalazłam mnóstwo cennych wskazówek o przewidywalności, przygotowaniu i dostosowaniu aktywności do potrzeb dziecka. Jedną z nich wykorzystałam dziś na basenie i wszystko przebiegło znacznie spokojniej. Polecam każdemu rodzicowi dziecka z ASD!",
    name: "Mama dziecka z ASD",
    role: "o e-booku „Wakacje w spektrum”",
  },
  {
    quote:
      "Miałam okazję jako pierwsza zapoznać się z e-bookiem o autyzmie u dziewczynek i kobiet. Ponad 100 stron czyta się jednym tchem, wszystko klarowne, z mnóstwem przykładów z życia. Nie widziałam jeszcze tak kompleksowych objaśnień. Zdecydowanie polecam!",
    name: "Pierwsza czytelniczka",
    role: "o e-booku o dziewczynkach i kobietach",
  },
  {
    quote:
      "E-book bardzo wartościowy i napisany w prosty, przystępny sposób. Ogromnym plusem są liczne przykłady z życia. Podejście pełne empatii i uważności. Może być dużym wsparciem dla rodziców, nauczycieli i specjalistów.",
    name: "Czytelniczka",
    role: "o e-booku o dziewczynkach i kobietach",
  },
  {
    quote:
      "Jestem pod ogromnym wrażeniem wiedzy Pani Justyny. Bardzo szczegółowo i przystępnie przekazane informacje. Te e-booki to naprawdę skarbnica wiedzy. Bardzo gratuluję, świetna robota!",
    name: "Zadowolona czytelniczka",
    role: "o e-bookach",
  },
  {
    quote:
      "Bardzo fajnie napisany e-book, dużo informacji, żeby zrozumieć zachowanie dziecka oraz z jakimi wyzwaniami możemy mierzyć się w przyszłości. Dziękuję!",
    name: "Rodzic",
    role: "opinia o e-booku",
  },
];

export const FAQS = [
  {
    q: "W jakim formacie otrzymam materiały?",
    a: "Wszystkie materiały to pliki PDF w wysokiej rozdzielczości, gotowe do wydruku lub użycia na tablecie.",
  },
  {
    q: "Czy mogę drukować materiały wielokrotnie?",
    a: "Tak. Po zakupie możesz drukować materiały do własnego, niekomercyjnego użytku bez ograniczeń.",
  },
  {
    q: "Dla kogo są te e-booki?",
    a: "Dla nauczycieli, terapeutów i rodziców dzieci w spektrum autyzmu, którzy szukają praktycznych narzędzi.",
  },
  {
    q: "Jak szybko otrzymam dostęp?",
    a: "Natychmiast po zakupie otrzymasz link do pobrania na swój adres e-mail.",
  },
];
